import { useRef, useState } from "react";
import { ButtonGroup, Form } from "react-bootstrap";

const FileUpdloadForm = (props: any) => {
    // const [fileSelectedFile, setFileSelectedFile] = useState(null)
    // const fileImport = useRef(null);
    
    const onFileSelectedChange = (e: any) => {
        try {
            // setFileSelectedFile(e.target.files[0])

            if (props.SuscribeChanges) props.SuscribeChanges(e);

        } catch (error) {
            console.log(error);
        }
    }

    return(
        <>
            <Form.Control type="file" 
                accept={props.Accept ? props.Accept : ".xlsx"}
                size="sm"
                onChange={(e: any) => onFileSelectedChange(e)}
                className={props.Classname}
                ref={props.ControlRef || null} />
        </>
    )
}

export default FileUpdloadForm;